import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";

import styled from "styled-components";

import { Link } from "react-router-dom";
import darkflix from "../images/darkflix.webp";
import blog from "../images/dee-blog.png";
import qBase from "../images/q-base.png";
import destate1 from "../images/destate1.webp";

export default function Slider() {
  return (
    <>
      <Container>
        <Swiper
          pagination={{
            type: "progressbar",
          }}
          navigation={true}
          modules={[Pagination, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide>
            <Image>
              <Link to="/project4">
                <img
                  src={qBase}
                  alt="QUICK_BASE"
                  data-aos="fade-up-left"
                  loading="lazy"
                />
              </Link>
            </Image>
          </SwiperSlide>
          <SwiperSlide>
            <Image>
              <Link to="/project1">
                <img src={darkflix} alt="DARKFLIX" data-aos="fade-up-left" />
              </Link>
            </Image>
          </SwiperSlide>
          <SwiperSlide>
            <Image>
              <Link to="/project2">
                <img
                  src={blog}
                  alt="vasse"
                  data-aos="fade-up-left"
                  loading="lazy"
                />
              </Link>
            </Image>
          </SwiperSlide>
          <SwiperSlide>
            <Image>
              <Link to="/project3">
                <img src={destate1} alt="Destate" data-aos="fade-up-left" />
              </Link>
            </Image>
          </SwiperSlide>
        </Swiper>
      </Container>
    </>
  );
}

const Container = styled.div`
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
  height: 70vh;
`;

const Image = styled.div`
  flex: 1;
  width: 100%;
  height: 400px;
  margin-right: 2rem;
  display: flex;
  justify-content: center;
  /* align-items: center; */

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
